import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { Avatar, Box, IconButton, Menu, MenuItem, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import environment from "../../../environments/environment";
import { resetParticipantAdminProfile } from "../../../store/features/auth/participantAdminProfileSlice";
import { saveAuditlog } from "../../fiscalUpgrade/services/AuditLogs/AuditLogsServices";
import { getCurrentPSTTime } from "../../fiscalUpgrade/Utils/dayjsWithTZ";
import SwitchParticipant from "../../PopUp/SwitchPartcipant";
import { UserProfileProps } from "./types";

const ProfileContainer = styled(Box)({
  display: "flex",
  alignItems: "center",
  gap: "3px",
  cursor: "pointer"
});

const UserInfo = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  color: theme.palette.text.secondary,
}));

// New Row Container for Name + Icon
const NameRow = styled(Box)({
  display: "flex",
  alignItems: "center",
  gap: "5px", // Space between name and icon 
});

const UserName = styled(Typography)({
  fontSize: "14px",
  fontWeight: 700,
  color: "#ffff",
});

const UserRole = styled(Typography)({
  fontSize: "12px",
  fontWeight: 600,
  color: "#ffff"
});

export const UserProfile: React.FC<UserProfileProps> = ({ user, onProfileClick }) => {
  const { t } = useTranslation();
  const translate = t as (key: string) => string;
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [switchPartcipantFlag, setSwitchPartcipantFlag] = useState<boolean>(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const open = Boolean(anchorEl);

  const handleMenuOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };
  const handleMenuItemClick = (route: string) => {
    if (route === "SignOut") {
      if (user.isLogin) {
        const auditLogs = {
          auditLogId: 0,
          dateChanged: getCurrentPSTTime(),
          clientId: user.clientId,
          participantId: user.defaultParticipantId,
          user: `${user.firstName} ${user.lastName}`,
          event: "Logout",
          description: `${user.firstName} has Logout.`,
          amount: 0.0,
          version: 0
        };
        dispatch(resetParticipantAdminProfile());
        saveAuditlog(auditLogs).finally(() => {
          window.location.href = `https://login.microsoftonline.com/${environment.tenant}/oauth2/logout?post_logout_redirect_uri=${environment.ApplicationURL}`;
        });
      } else {
        navigate(route);
      }
    } else {
      navigate(route);
    }
    handleMenuClose();
  };

  function formatRole(role: string) {
    return role
      .toLowerCase() // Convert to lowercase
      .split('_') // Split by underscores
      .map(word => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize the first letter of each word
      .join(' '); // Join the words with spaces
  }


  return (
    <>
      {user?.isLogin == true && <ProfileContainer onClick={onProfileClick}>
        {/* <img
          src="https://cdn.builder.io/api/v1/image/assets/TEMP/63796e40685a37e9f8bb4dfe3a015756b7ced38dde3a7ff1c6e3fdc900dd840a?placeholderIfAbsent=true&apiKey=2a10ec9e4ca34b8dabe8333a653afe75"
          alt="Notifications"
          style={{ width: '30px', height: '36px' }}
          loading="lazy"
        /> */}
        <Avatar sx={{ background: "#0A558C" }}>{user.avatar}</Avatar>
        <UserInfo>
          {/* Name and Icon in the same row */}
          <NameRow>
            <UserName variant="body1"  >{user.name}</UserName>
            <IconButton size="small" onClick={handleMenuOpen} sx={{ height: "10px" }}>
              <KeyboardArrowDownIcon sx={{ color: "white" }} />
            </IconButton>
            <Menu anchorEl={anchorEl} open={open} onClose={handleMenuClose} disableScrollLock sx={{
              "& .MuiPaper-root": {
                backgroundColor: "white",
                color: "black",
                minWidth: "200px",
              },
            }}>

              <MenuItem onClick={() => handleMenuItemClick("/profileSettings")}>
                <AccountCircleIcon style={{ marginRight: 8 }} />
                {translate('profileSettings')}
              </MenuItem>
              <MenuItem onClick={() => handleMenuItemClick("SignOut")}>
                <ExitToAppIcon style={{ marginRight: 8 }} />
                {translate('signOut')}
              </MenuItem>
            </Menu>
          </NameRow>
          <UserRole variant="body2">{formatRole(user.role)}</UserRole>
        </UserInfo>
        <SwitchParticipant
          setSwitchPartcipantFlag={setSwitchPartcipantFlag}
          open={switchPartcipantFlag}
          titlePopUp={translate('selectParticipantToSwitch')}
        />
      </ProfileContainer>}
    </>
  );
};
